import React          from 'react';
import { useHistory } from 'react-router';

import { Spinner }           from '../../common/spinner/spinner';
import { setCtxFields }      from '../../../context/ctx-actions';
import { GLOBAL_INIT_STATE } from '../../../context/ctx-constants';
import { useGlobalCtx }      from '../../../context/ctx-hook';
import { ROUTES }            from '../../../helpers/constants/constants';
import { callQAMSignOut }    from '../../../network/network-calls';

const deleteCookie = key => `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.quicken.com`;
function LogOut() {
  const {push}                  = useHistory();
  const {globalDispatch, state} = useGlobalCtx();
  const IS_CANADA               = state.country === 'ca';

  React.useEffect(() => {
    const SIGN_OUT_TOKEN = localStorage.getItem('signout');

    if (SIGN_OUT_TOKEN) {
      callQAMSignOut(SIGN_OUT_TOKEN, IS_CANADA).finally(() => {
        document.cookie = deleteCookie('qkn_bearer');
        document.cookie = deleteCookie('qkn_signout');
        const retainPromo = localStorage.getItem('bmPromos');
        localStorage.clear();
        if(retainPromo) {
          localStorage.setItem('bmPromos', retainPromo);
        }

        globalDispatch(setCtxFields(GLOBAL_INIT_STATE));
        push(ROUTES.LOGIN);
      });
    } else {
      document.cookie = deleteCookie('qkn_bearer');
      const retainPromo = localStorage.getItem('bmPromos');
      localStorage.clear();
      if(retainPromo) {
        localStorage.setItem('bmPromos', retainPromo);
      }

      globalDispatch(setCtxFields(GLOBAL_INIT_STATE));
      push(ROUTES.LOGIN);
    }
  }, [globalDispatch, push, IS_CANADA]);

  return <Spinner/>;
}

LogOut.displayName = 'LogOut';
export { LogOut };
